import {wwwUrlTo} from '@/lib/urlTo'

const SITE_LOGO = 'https://open-cdn.osello.com/brand/banner/meta.png'
const SITE_DESCRIPTION =
    "Create and optimize Macy's, Nordstrom, Target and other marketplace fashion & apparel listings automatically with the power of AI agents."

/**
 * Site-wide Organization + optional SoftwareApplication JSON-LD for the www marketing site.
 * `<` is escaped so values can never break out of the script tag.
 *
 * SoftwareApplication belongs on product/pricing pages only — repeating it on ~1,200 taxonomy
 * directory URLs triggers Semrush "invalid structured data" noise without SEO benefit.
 */
export function buildWwwSiteJsonLd({includeSoftwareApplication = true}: {includeSoftwareApplication?: boolean} = {}): string {
    const siteUrl = wwwUrlTo('').replace(/\/$/, '')
    const orgId = `${siteUrl}#organization`

    const graph: object[] = [
        {
            '@type': 'Organization',
            '@id': orgId,
            name: 'Osello',
            url: siteUrl,
            logo: SITE_LOGO,
            sameAs: [
                'https://www.linkedin.com/company/osello/',
                'https://twitter.com/osello_com',
                'https://www.facebook.com/osellocom',
            ],
        },
    ]

    if (includeSoftwareApplication) {
        graph.push({
            '@type': 'SoftwareApplication',
            '@id': `${siteUrl}#software`,
            name: 'Osello',
            applicationCategory: 'https://schema.org/BusinessApplication',
            operatingSystem: 'Web',
            url: siteUrl,
            description: SITE_DESCRIPTION,
            image: SITE_LOGO,
            offers: {
                '@type': 'Offer',
                price: 0,
                priceCurrency: 'USD',
                availability: 'https://schema.org/InStock',
                url: `${siteUrl}/pricing`,
            },
            publisher: {'@id': orgId},
        })
    }

    return JSON.stringify({
        '@context': 'https://schema.org',
        '@graph': graph,
    }).replace(/</g, '\\u003c')
}
